import { createSlice } from '@reduxjs/toolkit';
import {
  getListExtraReducers,
  getListReducers,
  listInitialState,
} from '@app/common/list/listSlice';
import setUserData from '../session/setUserDataThunk';
import fetchOrders from './fetchOrders';
import { InitialStateInterface, OrderFilters } from '../ordersTable/types';

export const initialState: InitialStateInterface = {
  ...listInitialState,
  filters: {
    ...listInitialState.filters,
    ordersState: 'ordered',
    searchText: '',
    type: '',
    category: '',
  },
};

export default createSlice({
  name: 'orders',
  initialState,
  reducers: getListReducers<OrderFilters, InitialStateInterface>(),
  extraReducers: {
    ...getListExtraReducers<InitialStateInterface>(fetchOrders, setUserData),
  },
});
